import { createContext, useContext, useState } from "react";

type DateFilterContextType = {
    startDate: Date | null;
    endDate: Date | null;
    setRange: (start: Date | null, end: Date | null) => void;
    reset: () => void;
};

const DateFilterContext = createContext<DateFilterContextType | undefined>(undefined);

export function DateFilterProvider({ children }: { children: React.ReactNode }) {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const setRange = (start: Date | null, end: Date | null) => {
        setStartDate(start);
        setEndDate(end);
    };

    const reset = () => {
        setStartDate(null);
        setEndDate(null);
    };

    return (
        <DateFilterContext.Provider value={{ startDate, endDate, setRange, reset }}>
            {children}
        </DateFilterContext.Provider>
    );
}

export function useDateFilterContext() {
    const context = useContext(DateFilterContext);
    if (!context) throw new Error("useDateFilterContext must be used inside DateFilterProvider");
    return context;
}
